export { VpTabButtonGroup } from './VpTabButtonGroup';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTabButtonGroup/index.js